// extracted by mini-css-extract-plugin
export default {"placeholderUnder700":"Sceleton_placeholderUnder700__UyUSb","placeholderAnimate":"Sceleton_placeholderAnimate__4uVXq"};